// extracted by mini-css-extract-plugin
module.exports =  {"root":"fFkBidfJZOVP5vJ3yWBJ"};